import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  apiUrl(): string {
    return environment.apiUrl;
  }

  insightsApiUrl(): string {
    return environment.insightsApiUrl;
  }
}
